import { logger } from "@/utils/logger"
import { TrackEvent } from "./trackEvent.interface"

export const trackEventMock: TrackEvent = (eventName, params) => {
  logger.debug("[Action:Started] Dispatch event", eventName, params)
}
